import { render, staticRenderFns } from "./ArticoloLottiPicking.vue?vue&type=template&id=b6c612cc&"
import script from "./ArticoloLottiPicking.vue?vue&type=script&lang=js&"
export * from "./ArticoloLottiPicking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports